import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useBrandModal } from "../context/BrandModalContext";
import { BrandSystemContent } from "../pages/BrandSystem";

export const BrandSystemModal = () => {
  const { open, closeModal } = useBrandModal();

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    const onKey = (e) => { if (e.key === "Escape") closeModal(); };
    if (open) window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open, closeModal]);

  return (
    <AnimatePresence>
      {open && (
        <div data-testid="brand-system-modal" className="fixed inset-0 z-[80]">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="absolute inset-0 bg-ink/70 backdrop-blur-sm"
            onClick={closeModal}
          />
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 40 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            className="absolute inset-x-0 top-[3vh] bottom-0 md:inset-x-[5vw] bg-white shadow-2xl overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <BrandSystemContent onClose={closeModal} />
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};
